<template>
  <div>
    <v-container>
      <h1>{{ title }}</h1>
      <v-expansion-panels multiple v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-header>Payroll Location</v-expansion-panel-header>
          <v-expansion-panel-content>
            <pay-loc-selection
              :show-dense="false"
              :headers="payLocHeaders"
              :show-select="true"
              v-model="payLoc"
              :by-user="true"
            ></pay-loc-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Department</v-expansion-panel-header>
          <v-expansion-panel-content>
            <department-selection
              :show-dense="false"
              :show-select="true"
              v-model="department"
            ></department-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Division</v-expansion-panel-header>
          <v-expansion-panel-content>
            <division-selection
              :show-dense="false"
              :show-select="true"
              v-model="division"
            ></division-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Branch</v-expansion-panel-header>
          <v-expansion-panel-content>
            <branch-selection
              :show-dense="false"
              :show-select="true"
              v-model="branch"
            ></branch-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Section</v-expansion-panel-header>
          <v-expansion-panel-content>
            <section-selection
              :show-dense="false"
              :show-select="true"
              v-model="section"
            ></section-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-row>
        <v-col>
          <v-btn text outlined @click.stop="search" :loading="isSearching"
            >Search</v-btn
          >
        </v-col>
      </v-row>
      <br />
      <v-data-table
        :items="employees"
        :headers="headers"
        v-if="employees.length > 0"
        show-select
        v-model="selected"
        item-key="empCode"
      ></v-data-table>
      <v-row v-if="employees.length > 0">
        <v-col cols="12" xs="12" sm="6" md="4">
          <email-type-selection v-model="emailType"></email-type-selection>
        </v-col>
      </v-row>
      <v-row v-if="employees.length > 0">
        <v-col>
          <v-btn text outlined @click.stop="send" :loading="isSending"
            >Send Email</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
const PayLocSelection = () =>
  import("../../setup/general/payroll-location/NewSelection");
const DepartmentSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/department/NewSelection"
  );

const DivisionSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/division/NewSelection"
  );
const BranchSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/branch/NewSelection"
  );

const SectionSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/section/NewSelection"
  );

const EmailTypeSelection = () =>
  import("../../setup/general/email-format/other-notif/Selection.vue");
import userAccessMixin from "../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/otherEmailNotif";
export default {
  metaInfo: {
    title: "Other Email Notification",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
  },
  mixins: [userAccessMixin],
  data: () => ({
    title: "Other Email Notification",
    payLoc: [],
    department: [],
    division: [],
    branch: [],
    section: [],
    employees: [],
    headers: [
      {
        text: "Employee Code",
        value: "empCode",
        sortable: false,
      },
      {
        text: "Name",
        value: "fullName",
        sortable: false,
      },
    ],
    isSearching: false,
    isSending: false,
    selected: [],
    panel: [],
    payLocHeaders: [
      {
        text: "Loc Id",
        value: "locId",
        sortable: false,
      },
      {
        text: "Description",
        value: "locName",
        sortable: false,
      },
    ],
    emailType: "",
  }),
  components: {
    PayLocSelection,
    DepartmentSelection,
    DivisionSelection,
    BranchSelection,
    SectionSelection,
    EmailTypeSelection,
  },
  computed: {
    grp() {
      return this.payLoc.join(", ");
    },
    dep() {
      return this.department.join(", ");
    },
    div() {
      return this.division.join(", ");
    },
    bra() {
      return this.branch.join(", ");
    },
    sec() {
      return this.section.join(", ");
    },
  },
  methods: {
    search() {
      this.isSearching = true;
      var param = {
        PayLoc: this.grp,
        Department: this.dep,
        Division: this.div,
        Branch: this.bra,
        Section: this.sec,
      };
      this.$axios
        .post(`${API_ENDPOINT}/employees`, param)
        .then(({ data }) => {
          this.employees = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => (this.isSearching = false));
    },
    send() {
      this.isSending = true;
      var param = {
        EmpCodes: this.selected.map((o) => o.empCode),
        EmailType: this.emailType,
      };
      this.$axios
        .post(`${API_ENDPOINT}/send`, param)
        .then(({ data }) => {
          this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => (this.isSending = false));
    },
  },
};
</script>
